<template>
  <LoadingScreen :caption="'Studio...'" v-if="!isInitialized" />
  <router-view v-else></router-view>
</template>

<script>
import LoadingScreen from "@/components/modals/LoadingScreen";
import { mapActions, mapGetters } from "vuex";
import { CONSOLE_MODES, FEATURE_FLAGS } from "@/store/core/UI/initialState";

export default {
  components: {
    LoadingScreen,
  },
  computed: {
    ...mapGetters("ClustersStudio", ["isInitialized"]),
  },
  methods: {
    ...mapActions("ClustersStudio", [
      "initializeConsole",
      "setCurrentConsole",
      "reset",
    ]),
    ...mapActions("DataManager", ["initializeDataManager"]),
    ...mapActions("Comments", ["fetchComments"]),
    initialize({
      dashboard_id,
      mode,
      featureFlags,
      isTemp = false,
      isPublic = false,
    }) {
      // this.fetchComments({
      //   dashboard_id,
      //   mode,
      // });
      this.initializeDataManager({ isTemp, isPublic });

      this.initializeConsole({
        dashboard_id,
        mode,
        featureFlags,
      });
    },
  },
  async mounted() {
    const { mode, cluster_id } = this.$route.params;

    let modes = {
      view: CONSOLE_MODES.VIEW,
      edit: CONSOLE_MODES.EDIT,
    };

    this.initialize({
      dashboard_id: cluster_id,
      mode: modes[mode],
      isTemp: mode == "edit",
      featureFlags: {
        [FEATURE_FLAGS.CREATE_METRIC]: false,
        [FEATURE_FLAGS.EDIT_METRIC]: false,
        [FEATURE_FLAGS.ADD_AREA_FILTER_FROM_LEGEND]: false,
        [FEATURE_FLAGS.EDIT_AREA_FILTERS]: false,
        [FEATURE_FLAGS.CONSOLE_DETAILS_IN_THE_CONSOLE_PANEL]: true,
        [FEATURE_FLAGS.CAN_EDIT_CITY]: false,
        [FEATURE_FLAGS.CAN_EDIT_GRID_SIZE]: false,
        [FEATURE_FLAGS.SHOW_ADD_COMMENTS_IN_CONTEXT_MENU]: false,
      },
    });
  },
  async beforeDestroy() {
    await this.reset();
  },
};
</script>

<style></style>
